import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  ${({ theme, isSmall }) => theme.resFontSize[isSmall ? "small" : "medium"]};
  ul{
    padding:0px 0px 0px 20px;
    list-style:disc;
    margin-bottom:20px;
  }
`;

const TextSection = ({ className, isSmall, children }) => {
  const classes = ["TextSection"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")} isSmall={isSmall}>
      {children}
    </Wrapper>
  );
};

TextSection.displayName = "TextSection";

TextSection.propTypes = {
  className: PropTypes.string,
  isSmall: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

TextSection.defaultProps = {
  className: null,
  isSmall: false,
};

export default TextSection;
